
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
    import AddOrUpdate from "./salary-school-add-or-update"
    @Component({
        name:'xygz',
        components:{
            AddOrUpdate
        }
    })
    export default class kqtj extends Vue {
        // currentTime = this.$moment().subtract(1,'months').toDate()  //获取上个月今天的日期（转换为时间格式）
        // maxMonth = this.$moment().subtract(1,'months')  //获取上个月今天的日期
        currentTime = this.$moment().toDate()
        maxMonth = this.$moment()
        depts=[]
        childDepts=[]
        deptdisable=false
        childdeptdisable=false
        dept=''
        childDept=''
        searchGw=''
        searchName=''
        dataGenState=false
        currentPage=1  //当前页
        countsize=0   //总条目数
        dataList = []
        tableLoad = false;
        addOrUpdateVisible=false

        mounted() {
            this.getDepts()
            this.getData()
        }

        getDepts(){
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }
            }).then(res => {
                this.depts = res.data
                if(this.depts && this.depts[0]) {
                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if(zzdyqc){
                        if(zzdyqc != this.CONST_ZN_BM) {
                            var zw = this.$store.getters.user.zw;
                            if(zw) {
                                if(zw=='01'||zw=='02'||zw=='03') {
                                    this.dept = this.depts[0].bmid
                                    this.deptdisable = true
                                    if(zw !='01') {
                                        this.childdeptdisable =true;
                                    }

                                }
                            }
                        }
                    }
                }
                // this.selectChanged2(this.dept)
            })
        }
       /* selectChanged2(value) {
            this.currentPage =1
            this.childDepts = []
            this.childDept =''
            this.$request({
                method: 'get',
                url: '/bjba/kqtj/getMentForUser2',
                params: {
                    fbmid: value,
                    userid:this.$store.getters.username
                }
            }).then((response) => {
                this.childDepts = response.data;
                var zzdyqc = this.$store.getters.user.zzdyqc;
                if(zzdyqc){
                    if(zzdyqc != this.CONST_ZN_BM) {
                        var zw = this.$store.getters.user.zw;

                        if(zw) {
                            if(zw=='02'||zw=='03') {
                                if(this.childDepts[0]) {
                                    this.childDept = this.childDepts[0].bmid

                                }
                            }
                        }
                    }

                }

            }).catch((err) => {
                console.log(err)
            })
        }*/

        getData() {
            // this.tableLoad = true
            let month = this.$moment(this.currentTime).format('YYYY-MM') //格式化上个月时间
            console.log("this.$moment(this.currentTime).format('YYYY-MM')的数据为：",month)
            this.$request.get(`/bjba/salary/school/infoByMonth/${month}`).then(res => {
                console.log("查询工资数据是否生成：",res)
               if(res.status === 200 && res.data.code === 200 && res.data.data.length > 0) {
                    this.$nextTick(() => {
                        this.dataGenState = true
                        this.selectChanged()
                    })
               } else {
                    this.$nextTick(() => {
                        this.dataGenState = false
                    })
               }
            })
        }

        getGzData() {
            this.tableLoad = true
            let month = this.$moment(this.currentTime).format('YYYY-MM')
            
            var orders = encodeURI(JSON.stringify([
                {
                    orderColumn: "bmid",
                    orderState: "ascending"
                },
                {
                    orderColumn: "gwmc",
                    orderState: "ascending"
                },
                {
                    orderColumn: "zygh",
                    orderState: "ascending"
                }
            ]));
            this.$request({
                method: 'get',
                url:'/bjba/salary/school/list',
                params:{page:this.currentPage,pagesize:10,month:month,bmid:this.dept,zyxm:this.searchName,gwmc:this.searchGw,orders:orders}
            }).then(res => {
                this.$nextTick(() => {
                    this.tableLoad = false
                    this.dataList = res.data.data.content
                    this.countsize = res.data.data.totalElements
                })
            }).catch(err => {
                this.$message({
                    message: '获取列表出现异常!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
                this.tableLoad = false
                console.log(err)
            })
        }

        selectChanged(){
            this.currentPage =1;
            this.getGzData()
        }

        lastmonth(){
            this.currentTime = this.$moment(this.currentTime).subtract(1,'months').toDate()  //获取指定时间往前推一个月的数据
            this.currentPage = 1
            this.countsize = 0
            this.dataList = []
            this.getData()

        }
        nextmonth(){
            this.currentTime = this.$moment(this.currentTime).add(1,'months').toDate()  //获取指定时间往后推一个月的数据
            this.currentPage = 1
            this.countsize = 0
            this.dataList = []
            this.getData()
        }

        handleCurrentChange(){
            this.getGzData()
        }

        get canNextMonth() {
            // return this.$moment(this.currentTime).isSame(this.maxMonth,'month')  // 日期比较，判断两个日期月份是否相同
            return false;
        }

        showBatchinOut() {
            let month = this.$moment(this.currentTime).format('YYYY-MM')
            var viewUrl = this.$request.defaults.baseURL + '/bjba/salary/school/exportExcel?bmid=' + this.dept + '&gwmc=' + this.searchGw + '&zyxm=' + this.searchName + '&month=' + month + '&type=0&access_token=' + this.$store.getters.token
            window.open(viewUrl)
        }

        updateHanlder(row:any) {
            this.addOrUpdateVisible = true
            let month = this.$moment(this.currentTime).format('YYYY-MM')
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row,month)
            })
        }

        updateXygzData() {
            this.$confirm('是否确定进行[数据更新]操作', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.createXygzData()
			}).catch(() => {});
        }

        deleteXygz(id: String) {
			this.$confirm('是否确定进行[删除]操作', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$request({
						url: '/bjba/salary/school/delete',
						method: 'get',
						params: {
							id: id
						}
					})
					.then(response => {
						let data = response.data;
						if (data.code == 200) {
							this.$message.success(data.message)
						} else {
							this.$message.error(data.message)
						}
						this.getData()
					})
					.catch(error => {
						console.log(error)
						this.$message.error("删除失败！")
					});
			}).catch(() => {});
		}

        createXygzData() {
            let month = this.$moment(this.currentTime).format('YYYY-MM')  //格式化上个月时间
            const loading = this.$loading({
				lock: true,
				text: '正在生成中，请耐心等待...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
            this.$request({
                method: 'post',
                url: '/bjba/salary/school/createXygzData',
                params: {month:month}
            }).then(res => {
                loading.close();
                console.log("生成工资返回的数据为：",res)
                if(res.status === 200 && res.data.code === 200) {
                    this.$message({
                        message: "数据生成成功！",
                        type: 'success',
                        duration: 1500
                    })
                    this.getData()
                    // location.reload()
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 3000
                    })
                }
            }).catch((err) => {
                loading.close();
                this.$message({
                    message: "数据生成失败！",
                    type: 'error',
                    duration: 3000
                })
                console.log(err)
            })
        }

    }
